import { theme } from '@theme';
import { DealType } from '../enums/DealType';

export const useDealType = (): DealTypeColumn => {
  const getColorCode = (dealType: string): string => {
    const dealTypeSwitch = dealType.toString();
    switch (dealTypeSwitch) {
      case DealType.Lease:
        return theme.palette.infoBlue;
      case DealType.Cash:
        return theme.palette.green;
      case DealType.Finance:
        return theme.palette.yellow;
      case DealType.Service:
        return theme.palette.sidebarGradient.from;
      case DealType.New:
        return theme.palette.darkCyan;
      default:
        return theme.palette.lightGray;
    }
  };

  const getDealTypeLabel = (dealType: number): string => {
    const dealTypeSwitch = dealType;
    switch (dealTypeSwitch) {
      case 1:
        return DealType.Lease;
      case 2:
        return DealType.Finance;
      case 4:
        return DealType.Cash;
      case 8:
        return DealType.Service;
      case 16:
        return DealType.New;
      case 32:
        return DealType.Unknown;
      default:
        return DealType.Lease;
    }
  };

  const getDealTypeNumber = (dealType: string): number => {
    switch (dealType.toLowerCase()) {
      case DealType.Lease.toLowerCase():
        return 1;
      case DealType.Cash.toLowerCase():
        return 4;
      case DealType.Finance.toLowerCase():
        return 2;
      case DealType.Service.toLowerCase():
        return 8;
      case DealType.New.toLowerCase():
        return 16;
      case DealType.Unknown.toLowerCase():
        return 32;
      default:
        return null;
    }
  };

  return { getColorCode, getDealTypeLabel, getDealTypeNumber };
};

type DealTypeColumn = {
  getColorCode(dealType: string): string;
  getDealTypeLabel(dealType: number): string;
  getDealTypeNumber(dealType: string): number;
};
